import banner from "./banner.jpeg";
import point from "./point.gif";
import abc from "./ABC.webp";
import hobuden from "./hobuden.jpeg";
import "./App.css";

import { AiFillPhone } from "react-icons/ai";
import { MdSmartphone } from "react-icons/md";
import { BsFillPinMapFill } from "react-icons/bs";
import { SiLine } from "react-icons/si";

function SectionTitle({ children }) {
  return (
    <div className="point-body">
      <img src={point} className="point" alt="" aria-hidden="true" />
      <div className="point-text">{children}</div>
    </div>
  );
}

function App() {
  return (
    <>
      <nav className="site-nav" aria-label="メインナビゲーション">
        <a href="#lessons">コース</a>
        <a href="#about">方針・成果</a>
        <a href="#price">料金</a>
        <a href="#teacher">講師紹介</a>
        <a href="#contact" className="nav-cta">お問い合わせ</a>
      </nav>

      <main className="home">
        <header className="banner-container">
          <img src={banner} className="banner-logo" alt="ホブデン英語スクール バナー" />
          <div className="banner-overlay">
            <p className="overlay-tagline">福岡市南区　英会話・英語塾</p>
            <h1 className="overlay-title">ホブデン英語スクール</h1>
            <p className="overlay-sub">海外経験豊富な塾長と外国人講師がいます。</p>
            <a href="#contact" className="hero-cta-btn">無料体験・お問い合わせ</a>
          </div>
        </header>

        <div className="school-name-block">
          <p className="school-name-en">HOBDEN English School</p>
          <p className="school-name-kana">ホブデン イングリッシュ スクール</p>
        </div>

        <section id="lessons" aria-labelledby="lessons-heading">
          <SectionTitle>対応コース一覧</SectionTitle>
          <h2 id="lessons-heading" className="sr-only">対応コース一覧</h2>
          <div className="lesson-box">
            <ul className="lesson-list">
              <li>
                英会話
                <span>幼児・小学生</span>
              </li>
              <li>
                派遣
                <span>保育園・幼稚園</span>
              </li>
            </ul>

            <img src={abc} alt="英語学習イメージ" className="lesson-img" />

            <ul className="lesson-list">
              <li>
                英語塾
                <span>中学・高校</span>
              </li>
              <li>
                家庭教師
                <span>中学・高校</span>
              </li>
              <li>
                TOEIC
                <span>大学生・社会人</span>
              </li>
            </ul>
          </div>
        </section>

        <section id="about" aria-labelledby="about-heading">
          <SectionTitle>方針と成果</SectionTitle>

          <h2 id="about-heading">楽しく学び賢く育てる　学校の授業を徹底解説</h2>

          <p>
            ホブデンスクールは実践的な会話だけでなく学校での成績に責任をもちます。
            幼児会話から大学受験まで一貫した連携授業が特徴です。
            子供を観察し動機付けを行い、楽しく効率的なプログラムをたてるのが私たちの仕事です。
            本校の生徒の多くが10年以上通ってくれるのは、楽しい事のほかに、子ども自身が成果を実感できるからです。
            愛情と知育が一体化してこそ子供たちは健やかに伸びていき、目に見える結果を得て自信に満ちます。
            会話力を伸ばすのは当然ですが、生徒達の英検や大学入試共通テストの成績も素晴らしいものです。
            リスニングと英作文に強いのも当校の特徴です。
          </p>

          <p className="achievements">進学実績</p>
          <p>
            九州大学法科、青山学院大法科、中央大経済学部、金沢医学大、
            明治大学文学部、ルーマニア国立医大
            <br />
            修猷館高校、筑紫ヶ丘高校、西南高校、他
          </p>
        </section>

        <section id="price" aria-labelledby="price-heading">
          <SectionTitle>料金</SectionTitle>

          <ul className="cost-lines">
            <li>
              入会金 <span>無料</span>
            </li>
            <li className="cost-li1">
              <div className="left">教材費</div>
              <div className="right">
                <div>幼児:300円/月・小学生:450円/月</div>
                <div className="right-2">中学生以上:実費</div>
              </div>
            </li>
          </ul>

          <table className="cost-table" aria-label="月謝一覧">
            <thead>
              <tr>
                <th scope="col">クラス</th>
                <th scope="col">授業時間</th>
                <th scope="col">月謝</th>
                <th scope="col">割引</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>幼稚園児</td>
                <td>45分</td>
                <td>6,000円</td>
                <td>無</td>
              </tr>
              <tr>
                <td>小学会話</td>
                <td>60分</td>
                <td>8,000円</td>
                <td>有</td>
              </tr>
              <tr>
                <td>中学塾</td>
                <td>120分</td>
                <td>12,000円</td>
                <td>有</td>
              </tr>
              <tr>
                <td>高校塾</td>
                <td>120分</td>
                <td>13,000円</td>
                <td>有</td>
              </tr>
              <tr>
                <td>個人授業</td>
                <td>90分</td>
                <td>7,000円</td>
                <td>無</td>
              </tr>
              <tr>
                <td>幼稚園派遣</td>
                <td>30分から</td>
                <td>6,000円/30分</td>
                <td>無</td>
              </tr>
            </tbody>
          </table>
        </section>

        <section id="contact" aria-labelledby="contact-heading">
          <SectionTitle>問い合わせ</SectionTitle>

          <h2 id="contact-heading">ホブデン英語スクール本部</h2>

          <div className="contact-block">
            <a
              href="https://www.google.com/maps/place/%E3%83%9B%E3%83%96%E3%83%87%E3%83%B3%E8%8B%B1%E8%AA%9E%E3%82%B9%E3%82%AF%E3%83%BC%E3%83%AB/@33.5386919,130.3897041,17z/data=!3m1!4b1!4m6!3m5!1s0x354196abe14f9599:0x313bf3c87bc17dd0!8m2!3d33.538692!4d130.394575!16s%2Fg%2F11b5phx7st"
              target="_blank"
              rel="noreferrer"
              className="contact-map"
              aria-label="Googleマップで所在地を確認"
            >
              <BsFillPinMapFill aria-hidden="true" />
              福岡市南区桧原2-29-2
            </a>

            <div className="phone">
              <a href="tel:092-577-5689" aria-label="固定電話 092-577-5689">
                <AiFillPhone aria-hidden="true" />
                092-577-5689
              </a>

              <a href="tel:090-9597-7725" aria-label="携帯電話 090-9597-7725">
                <MdSmartphone aria-hidden="true" />
                090-9597-7725
              </a>
            </div>

            <a
              href="https://lin.ee/X1v9mPw"
              target="_blank"
              rel="noreferrer"
              className="line-btn"
              aria-label="公式LINEでお問い合わせ"
            >
              <SiLine aria-hidden="true" />
              公式LINEでお問い合わせ
            </a>

            <p className="contact-note">
              お気軽にお電話またはメールにてお問い合わせください。無料体験授業も受付中です。
            </p>
          </div>
        </section>

        <section id="teacher" aria-labelledby="teacher-heading">
          <SectionTitle>講師紹介</SectionTitle>

          <div className="teacher-card">
            <img
              src={hobuden}
              className="teacher-img"
              alt="学長 ホブデンユミ"
            />
            <div className="teacher-info">
              <p className="teacher-role">全担当</p>
              <h2 id="teacher-heading" className="teacher-name">学長 ホブデンユミ</h2>
              <p>
                海外在住歴が長く、日英独のトライリンガル。西洋事情に詳しく、子供を遊ばせるのが上手い反面、
                マナーに厳しい体育系気質の面もあり。
                <br />
                愛情と知育の一体化がモットー。教材も手作りが多くユニークな物が豊富。
                <br />
                英検1級、TOEIC950
              </p>
            </div>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <p className="footer-name">ホブデン英語スクール（HOBDEN English School）</p>
        <address>
          〒 福岡市南区桧原2-29-2
          <a href="tel:092-577-5689">TEL: 092-577-5689</a>
        </address>
        <p className="footer-copy">&copy; {new Date().getFullYear()} HOBDEN English School. All rights reserved.</p>
      </footer>
    </>
  );
}

export default App;
